export default __webpack_public_path__ + "static/media/029-instagram.46b73e79.svg";